module.exports = __webpack_public_path__ + "img/h_tutorial_step-1.1d3ad064.png";